import { render, staticRenderFns } from "./bulletin-add-or-update.vue?vue&type=template&id=b05c031e&"
import script from "./bulletin-add-or-update.vue?vue&type=script&lang=js&"
export * from "./bulletin-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports